module.exports = __webpack_public_path__ + "img/chart_sort.c51fa5f2.svg";